/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Config } from '@luggagehero/shared/environment';
import { Observable } from 'rxjs';

@Injectable()
export class BookingsyncService {
  private http = inject(HttpClient);

  connectAccount(authCode: string): Observable<any> {
    const url = `${Config.environment.PMS_INTEGRATIONS_API}/providers/bookingsync/connect`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    const payload = { code: authCode };
    return this.http.post(url, payload, { headers: headers });
  }

  getAccount(id: string): Observable<any> {
    const url = `${Config.environment.PMS_INTEGRATIONS_API}/providers/bookingsync/accounts/${id}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    return this.http.get(url, { headers: headers });
  }
}
